export default "/Frontend/dist/doc-fallback-hover.177591e0ca0720ef76ae3254887bd4ea.svg";